
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/30000-free-event-tickets-for-nhs-and-frontline-workers",
      function () {
        return require("private-next-pages/blog/30000-free-event-tickets-for-nhs-and-frontline-workers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/30000-free-event-tickets-for-nhs-and-frontline-workers"])
      });
    }
  